import type { WeightUnit } from "../preferences/types";

const poundsPerKilogram = 2.2046226218;

export function displayWeight(kilograms: number, unit: WeightUnit): number {
  return unit === "lb" ? kilograms * poundsPerKilogram : kilograms;
}

export function weightInKilograms(value: number, unit: WeightUnit): number {
  return unit === "lb" ? value / poundsPerKilogram : value;
}

export function roundWeightKilograms(value: number): number {
  return Math.round(value * 1000) / 1000;
}

export function weightUnitLabel(unit: WeightUnit): "kg" | "lb" {
  return unit;
}
